import { useEffect } from "react"
import { connect } from "react-redux"
import { verify, refresh, load_user } from "../../redux/actions/auth/auth"
import Navbar from "components/navigation/Navbar"

function Layout({
    children,
    verify,
    load_user,
    refresh,
    isAuthenticated,
}){

    useEffect(()=>{
        window.scrollTo(0,0)
        isAuthenticated ? <></>:
        <>
            {/* {refresh()}, */}
            {verify()}
            {load_user()}
        </> 
    }, [])

    return(
        <div className='bg-gray-50 flex flex-col min-h-screen'>
            <Navbar/>
            {children}
        </div>
    )
}

const mapStateToProps=state=>({
    isAuthenticated: state.auth.isAuthenticated
})

export default connect (mapStateToProps, {
   verify,
   refresh,
   load_user,
})(Layout)